export default "__VITE_ASSET__B493lV21__"